<template>
<div>

  <div id="musk" class="musk" style="display: none;">
    <div class="musk-bg"></div>
    <div class="musk-main">
      <div class="musk-txt">
        点击右上角 ... 按钮
        <br>
        分享健康日历给好友吧
      </div>
      <div class="musk-share-tip">
        <img src="../assets/share-tip.png" class="not_wx_preview">
      </div>
      <div class="musk-pic">
        <img class="musk-close not_wx_preview" src="../assets/close.png" @click="hideMusk">
        <img id="share-pic" class="not_wx_preview" :src="curSharePic">
      </div>
    </div>
  </div>
  <div id="list" tabindex="0" class="ui items middle aligned divided list asking-list">
    <div v-for="(itm,index) in items" v-bind:key="index" class="item">
      <div>
        <div class="content floating">
          <div class="center ui main-ctt">
            <template v-if="itm.type === 2">
              <video controls="controls" class="ui image center" :poster="itm.pic" :src="itm.video" style="width:100%;"></video>
            </template>
            <template v-else>
              <img class="ui image center" :src="itm.pic" style="width:100%;">
            </template>
            <div class="sharetxt">长按上图保存发圈
              <img src="../assets/finger.png" class="not_wx_preview" style="width: 2rem;position: absolute;left: 4rem;">
            </div>
          </div>
          <div style="margin: 0.5rem 0;">
            <a :href="itm.url" class="mybtn1 left floated" style="float:left; color: #FFFFFF!important" target="_blank">
              <img src="../assets/email.png" class="not_wx_preview">
              骨病知识
            </a>
            <a @click="share2wx(itm.pic)" href="javascript:" class="mybtn1 share2friends right floated" data-pic-path="/attach/db/43/e8/db43e86d0d2ee804b2d4d17be0716d1e.jpg" style=" float:right;color: #FFFFFF!important">
              <img src="../assets/share-sm.png" class="not_wx_preview">
              分享链接
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
<!--  <div id="more" class="more" @click="getMoreItem" style="display: none;height:0px;">加载更多~</div>-->
</div>

</template>

<script>
  export default {
    name:'Itm',
    data () {
      return {
        target:0,
        ischooseDay:0,
        searchKeytmp:'',
        chooseDaytmp:'',
        curPage:1,
        hasMore:1,
        curSharePic:'',
        items: [

        ]
      }
    },
    created() {
      // var searchkey = this.$store.getters.searchKey
      // console.log('searchkey ='+searchkey)

      // this.$store.commit('showLoading')
      this.getItemByPage(1)
      // this.$store.commit('hideLoading')
    },
    mounted () {
      let _this = this;
      window.onscroll = function(){
        //变量scrollTop是滚动条滚动时，距离顶部的距离
        var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
        //变量windowHeight是可视区的高度
        var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        //变量scrollHeight是滚动条的总高度
        var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
        //滚动条到底部的条件
        if (scrollTop+windowHeight === scrollHeight){
          //到了这个就可以进行业务逻辑加载后台数据了
          if (_this.hasMore === 1){
            ++_this.curPage
            _this.getItemByPage()
          }
        }
      }
      this.$nextTick(() => {
        setTimeout(() => {
          let targetbox= document.getElementById('list');
          this.target= targetbox.offsetTop;
          // console.log('target='+this.target)
        })
      })
    },
    updated() {
      // console.log('updated')
      // window.scrollTo(0, this.target)

      if (this.ischooseDay){
        this.go2list()
      }
    },
    computed:{
      searchKey(){
        return this.$store.state.searchKey
      },
      chooseDay(){
        return this.$store.state.chooseDay
      },
      incrChooseDay(){
        return this.$store.state.chooseDayCount
      }
    },
    watch:{
      searchKey(val){
        // console.log(val)
        this.curPage = 1
        this.searchKeytmp = this.$store.state.searchKey
        this.chooseDaytmp = ''
        this.getItemByPage(1)
        document.getElementById('list').focus()
        window.scrollTo(0, 300)
      },
      chooseDay(val){
        this.curPage = 1
        this.chooseDaytmp = this.$store.state.chooseDay
        this.searchKeytmp = ''
        this.getItemByPage(1)
        this.$store.commit('needScroll2list', true)
      },
      incrChooseDay(val){
        // let self = this
        // console.log('val is '+val+';this.$store.state.incrementChooseDay is '+this.$store.state.chooseDayCount)
        if (val>0){
          this.ischooseDay = 1
          /*
          // this.go2list(0, this.target)
          setTimeout(function () {
            self.go2list(0, self.target)
          }, 300)
          //*/
        }
      }
    },
    methods:{
      go2list(start, length){
        //滚动动画
        let self = this
        //*
        setTimeout(function () {
          if (start<length){
            start = start + (length-start)/10
            start = Math.ceil(start)
            window.scrollTo(0, start)
            // console.log('scroll to '+ start)
            self.go2list(start, length)
          }
        }, 15)
        //*/
        /*
        if (start<length){
          start = start + (length-start)/100
          start = Math.ceil(start)
          window.scrollTo(0, start)
          console.log('scroll to '+ start)
          self.go2list(start, length)
        }
        //*/
      },
      clearItems(){
        this.items = []
      },
      share2wx(pic){
        this.curSharePic = pic
        // console.log(pic)
        document.getElementById('musk').style.display = 'block';
      },
      hideMusk(){
        // console.log('clicked close btn')
        document.getElementById('musk').style.display = 'none';
      },
      getMoreItem(){
        ++this.curPage
        this.getItemByPage(0)
      },
      async getItemByPage(isnew=0){
    //*
        let self = this
        let url = self.serverUrl + 'health-calendar?page='+self.curPage+'&searchKey='+encodeURIComponent(self.searchKeytmp)+'&chooseDay='+self.chooseDaytmp
        if (isnew){
          self.clearItems()
          // url = self.serverUrl + 'health-calendar?page=1&searchKey='+encodeURIComponent(this.$store.state.searchKey)
        }
        self.$store.commit('showLoading')
        self.$store.commit('hasData')

        // await this.axios.get('http://api.o.com.cn/health-calendar?page='+self.curPage+'&searchKey='+encodeURIComponent(this.$store.state.searchKey)+'&chooseDay='+this.$store.state.chooseDay)
        await this.axios.get(url)
          .then(function (response) {
            self.$store.commit('hideLoading')
            // console.log(response.data);
            let data = response.data
            if (data.code === 200){
              // console.log(document.getElementById('list').scrollTop)
              self.$store.commit('hasData')
              self.$store.commit('hideLoading')
              if (data.hasMore === 0){
                self.hasMore= 0
                // document.getElementById('more').style.display = 'none';
              } else {
                self.hasMore= 1
                // document.getElementById('more').style.display = 'block';
              }
                var data2 = data.data
                for (var i in data2){
                  var html = {'type':data2[i].type, 'pic':data2[i].pic_path, 'video':data2[i].video_path, 'url':data2[i].link, 'day':data2[i].day}
                  // console.log(html)
                  self.items.push(html)
                  // console.log('this is '+ self)
                }
                // self.$store.commit('setCalendar', self.items)
            } else {
                // document.getElementById('more').style.display = 'none';
                self.clearItems()
                self.$store.commit('noData')
            }
          })
          .catch(function (error) {
            console.log(error);
            self.$store.commit('hideLoading')
          });
        // var html = {'id':123, 'title':'标题1', 'pic':'http://api.orthonline.com.cn/attach/db/43/e8/db43e86d0d2ee804b2d4d17be0716d1e.jpg', 'video':'http://api.orthonline.com.cn/attach/db/43/e8/db43e86d0d2ee804b2d4d17be0716d1e.jpg'};
        // this.items.push(html)
        //*/
      }
    }
  };
</script>
<style>
  html, body {
    background-color: #FFFFFF;
  }
  .more {
    color: #0e8c8c;
    text-align: center;
    margin:2rem 0 1rem 0;
  }

  .asking-list {
    padding: 0 10px !important;
  }

  .item {
    padding: 15px 0 !important;
  }

  .create_time, .realname {
    color: #0e8c8c;
  }

  .realname {
    float: left;
    margin-right: 5px;
  }

  .create_time {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    width: 70%;
    float: left;
  }

  .description {
    clear: both;
    color: #0e0e0e !important;
    margin-top: 0.77rem;
    padding-left: 50px;
    font-size: 0.95rem;
    /*font-size: 1.3rem !important;*/
    line-height: 1.45rem !important;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box !important;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .item .header {
    width: 55%;
  }

  .asking-button {
    z-index: 999;
    position: relative;
    display: block;
    color: #FFFFFF;
  }
  .main-ctt .sharetxt{
    background: #5cb85c;
    color: white;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    /*margin-top: -10px;*/
    display: block;
    z-index: 9999;
    border-top:1px solid white;
  }

  .ui.divided.items > .item{
    border-top:none;
    margin:0 0 1rem  0;
  }
  .musk{
    display: none;
  }
  .musk .musk-bg,.musk .musk-main{
    position: fixed;
    top:0;
    bottom:0;
    right:0;
    left:0;
    z-index: 3;
  }
  .musk .musk-bg{
    background: black;
    opacity: .7;
    z-index: 2;
  }
  .musk .musk-txt{
    margin: 2rem 0;
    text-align: center;
    font-size: 1.3rem;
    color: white;
    line-height: 2rem;
  }
  .musk .musk-main .musk-pic{
    text-align: center;
  }
  .musk .musk-main .musk-pic img{
    max-width:100%;
    width:75%;
  }
  .musk .musk-main .musk-pic img.musk-close{
    width: 30px;
    position: absolute;
    right: 4%;
    margin-top: -8%;
    cursor: pointer;
  }
  .musk .musk-main .musk-share-tip img{
    width:22%;
    position: absolute;
    right:1rem;
    top:1rem;
  }
  div.content div a{
    margin-top: 0px;
    color: #FFFFFF!important;
    background: #5cb85c;
    height: 2rem;
    line-height: 2rem;
    padding: 0 0.6rem;
    border-radius: 5px;
  }
  .mybtn1 img{
    width:1rem;
    margin-top: -0.3rem;
  }
  .ui.list .item a{
    color:white;
  }
  #list{
    /*margin: 1.5em 0em;*/
    font-size: 1em;
  }
  .main-ctt .sharetxt{
    background: #5cb85c;
    color: white;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    margin-top: -10px;
    display: block;
    z-index: 9999;
    border-top:1px solid white;
  }
  a{
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Itm.vue